import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import I from 'components/I'
import React from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useAccount } from 'state/Account'
import { ALL_LOCATIONS_ACTIVE, setActiveRestaurant, useActiveRestaurant, useRestaurants } from 'state/Restaurants'

export default function RestaurantSelector() {
	const { t }       = useTranslation()
	const dispatch    = useDispatch()
	const restaurants = useRestaurants()
	const selected    = useActiveRestaurant()
	const LOCATIONS   = useAccount().location_wording_plural

	function doSelect(id) {
		dispatch(setActiveRestaurant(id))
	}

	if (restaurants.length == 1) {
		return null
	}

	//region const multipleMarkers //little "easter egg" considering the number of locations the account has
	const multipleMarkers = restaurants.length == 2?
		<span className="fa-layers">
			<FontAwesomeIcon icon="map-marker-alt" opacity={0.6} transform="shrink-4 up-4 left-5"/>
			<FontAwesomeIcon icon="map-marker-alt" transform="right-3"/>
		</span>
			:
		<span className="fa-layers">
			<FontAwesomeIcon icon="map-marker-alt" opacity={0.6} transform="shrink-4 up-4 left-7"/>
			<FontAwesomeIcon icon="map-marker-alt" opacity={0.6} transform="shrink-4 up-4 right-7"/>
			<FontAwesomeIcon icon="map-marker-alt" transform="shrink-1"/>
		</span>
	//endregion

	//while the standard should be to use "all the locations", we kept "all locations" as it's understandable and shorter
	//see https://ellii.com/blog/answering-students-grammar-questions-when-do-i-use-all-of-the-all-the-or-all
	const allLocations = <>{multipleMarkers} <span className="pl-1"><I force>{t('All {{LOCATIONS}}', { LOCATIONS })}</I></span></>

	return <DropdownButton drop="up" id="selectRestaurant" variant="" onSelect={doSelect} //no variant makes for correct Reseller colors
	                title={selected?
		                <><FontAwesomeIcon icon="map-marker-alt"/> <span>{selected.display_name}</span></> : allLocations
	                }>
		<Dropdown.Item eventKey={ALL_LOCATIONS_ACTIVE}>{allLocations}</Dropdown.Item>
		{restaurants.map(r => <Dropdown.Item key={r.id} variant="light" eventKey={r.id}>{r.display_name}</Dropdown.Item>)}
	</DropdownButton>
}
